const DOCUMENT_TYPE_LABELS: Record<string, string> = {
  FIC: "FIC - Foreign Ingredient Certificate",
  IP: "IP - Import Permit",
  PAC: "PAC - Product Analysis Certificate",
  ADH: "ADH - EU Accompanying Document (Health Certificate)",
  ADM: "ADM - EU Accompanying Document (Cargo Manifest)",
  OTHER: "OTHER - Other types",
}

export function formatDocumentType(
  documentType: string | null,
): string | null {
  if (!documentType) return null
  return DOCUMENT_TYPE_LABELS[documentType] ?? documentType
}

export function resolveForeignPremisesId(value: unknown): string | null {
  if (Array.isArray(value)) {
    const filtered = value
      .map((id) => (typeof id === "number" ? String(id) : id))
      .filter((id): id is string => typeof id === "string")
    return filtered.length > 0 ? filtered.join(", ") : null
  }
  if (typeof value === "string") {
    return value
  }
  if (typeof value === "number") {
    return String(value)
  }
  return null
}
